module.exports = __webpack_public_path__ + "img/envelope-open-text.415e356e.svg";